import { render, staticRenderFns } from "./app-platform-reviews-count.vue?vue&type=template&id=0be19b1c&"
import script from "./app-platform-reviews-count.vue?vue&type=script&lang=js&"
export * from "./app-platform-reviews-count.vue?vue&type=script&lang=js&"
import style0 from "./app-platform-reviews-count.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports